import dayjs from 'dayjs';

const getAgeFromDate = date => {
  const years = dayjs().diff(date, 'years',false);
  return (!isNaN(years) && years > 0) ? years : "";
};

export default getAgeFromDate